export const CHANGE_CURRENT_SEARCH_VALUE = 'CHANGE_CURRENT_SEARCH_VALUE';
export const CHANGE_DEBOUNCED_SEARCH_VALUE = 'CHANGE_DEBOUNCED_SEARCH_VALUE';
export const RESET_SEARCH_VALUE = 'RESET_SEARCH_VALUE';

export const changeCurrentSearchValue = newSearchValue => ({
  type: CHANGE_CURRENT_SEARCH_VALUE,
  payload: newSearchValue,
});

export const changeDebouncedSearchValue = newSearchValue => ({
  type: CHANGE_DEBOUNCED_SEARCH_VALUE,
  payload: newSearchValue,
});

export const resetSearchValue = () => ({
  type: RESET_SEARCH_VALUE,
});
